import React, { useMemo } from "react";
import { useTranslate } from "@refinedev/core";
import { ChatSummaryStats } from "types/";
import { AnalyticsBarChart, type BarDatasetConfig } from "./AnalyticsBarChart";
import { analyticsTheme } from "./analyticsTheme";
import { getPercentageAxis, getCategoryAxis } from "./utils/";

const T_PREFIX = "media.projects.analytics.aiChatbot.persuasionOutcome";

export interface PersuasionOutcomeChartProps {
  data: ChatSummaryStats | null | undefined;
  loading: boolean;
}

export const PersuasionOutcomeChart: React.FC<PersuasionOutcomeChartProps> = ({
  data,
  loading,
}) => {
  const t = useTranslate();
  const chartOptions = useMemo(
    () => ({
      scales: { y: getPercentageAxis(), x: getCategoryAxis() },
    }),
    []
  );

  const total =
    (data?.convinced_sessions ?? 0) +
      (data?.not_convinced_sessions ?? 0) +
      (data?.uncertain_sessions ?? 0) || 1;

  const labels = useMemo(
    () => [
      t(`${T_PREFIX}.convinced`),
      t(`${T_PREFIX}.notConvinced`),
      t(`${T_PREFIX}.uncertain`),
    ],
    [t]
  );

  const datasets = useMemo<BarDatasetConfig[]>(
    () => [
      {
        label: t(`${T_PREFIX}.sessions`),
        data: [
          Math.round(((data?.convinced_sessions ?? 0) / total) * 100),
          Math.round(((data?.not_convinced_sessions ?? 0) / total) * 100),
          Math.round(((data?.uncertain_sessions ?? 0) / total) * 100),
        ],
        color: analyticsTheme.datasetEmerald,
      },
    ],
    [data, total, t]
  );

  return (
    <AnalyticsBarChart
      title={t(`${T_PREFIX}.title`)}
      labels={labels}
      datasets={datasets}
      loading={loading}
      direction="vertical"
      height={200}
      chartOptions={chartOptions}
    />
  );
};
